import {
  SalesOrderDeliveryStatusEnum,
  SalesOrderInvoiceStatusEnum,
  SalesOrderStatusEnum,
} from "./sales-order-status-enum";

export const salesOrderStatusLabels = {
  [SalesOrderStatusEnum.PAID]: "Lunas",
  [SalesOrderStatusEnum.VOID]: "Void",
};

export const salesOrderDeliveryStatusLabels = {
  [SalesOrderDeliveryStatusEnum.PENDING]: "Pending",
  [SalesOrderDeliveryStatusEnum.PARTIALLY_DELIVERED]: "Terkirim Sebagian",
  [SalesOrderDeliveryStatusEnum.FULLY_DELIVERED]: "Terkirim",
};

export const salesOrderInvoiceStatusLabels = {
  [SalesOrderInvoiceStatusEnum.PENDING]: "Pending",
  [SalesOrderInvoiceStatusEnum.PARTIALLY_INVOICED]: "Di Faktur Sebagian",
  [SalesOrderInvoiceStatusEnum.FULLY_INVOICED]: "Di Faktur",
};
